import { render, staticRenderFns } from "./quitEmployees.vue?vue&type=template&id=7843241a&scoped=true"
import script from "./quitEmployees.vue?vue&type=script&lang=js"
export * from "./quitEmployees.vue?vue&type=script&lang=js"
import style0 from "./quitEmployees.vue?vue&type=style&index=0&id=7843241a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7843241a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7843241a')) {
      api.createRecord('7843241a', component.options)
    } else {
      api.reload('7843241a', component.options)
    }
    module.hot.accept("./quitEmployees.vue?vue&type=template&id=7843241a&scoped=true", function () {
      api.rerender('7843241a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/components/index/quitEmployees.vue"
export default component.exports